import {createContext, useContext, useReducer} from 'react';

export interface State {
    loading: boolean;
}

export interface Action {
    type: string;
    payload: any;
}

const StateContext = createContext<State>({
    loading: false,
});
const DispatchContext = createContext<any>(null);

const reducer = (state: State, {type, payload}: Action) => {
    switch (type) {
        case 'START_LOADING':
            return {...state, loading: true};
        case 'STOP_LOADING':
            return {...state, loading: false};
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
};

export const ContextProvider = ({
                                    children,
                                }: {
    children: React.ReactNode;
}) => {
    const [state, defaultDispatch] = useReducer(reducer, {
        loading: false,
    });
    const dispatch = (type: string, payload?: any) =>
        defaultDispatch({type, payload});

    return (
        <DispatchContext.Provider value={dispatch}>
            <StateContext.Provider value={state}>{children}</StateContext.Provider>
        </DispatchContext.Provider>
    );
};
export const useContextState = () => useContext(StateContext);
export const useContextDispatch = () => useContext(DispatchContext);
